import ApiClient from './ApiClient';

class CustomFields extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }
}

export default new CustomFields();
